import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from './click-outside.directive';
import { CurrencyFormatDirective } from './currency-format.directive';
import { InfiniteScrollDirective } from './infinite-scroll.directive';
import { DecimalPipe } from '@angular/common';
import { UppercaseFormControlDirective } from './uppercase-formcontrol';

const directives = [
    InfiniteScrollDirective,
    ClickOutsideDirective,
    CurrencyFormatDirective,
    UppercaseFormControlDirective
];
@NgModule({
  declarations: directives,
  exports: directives,
  providers: [
    DecimalPipe
  ]
})
export class DirectivesModule { }
